import { apiUrl, postJson } from "./apiClient";

/** AI assistant endpoints (chat and reference-document links). */

/** POST /chat - resolves to the fetch Response. */
export const sendChatMessage = (message, history) => postJson("/chat", { message, history });

/**
 * Download link for a reference document. `encodedName` must already be URL-encoded
 * (the chat formatter also encodes parentheses so the markdown link cannot end early).
 */
export const documentDownloadUrl = (encodedName) => apiUrl(`/download-doc?filename=${encodedName}`);
